import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

const NUMEROUS_RELEASES = gql(`
  query numerousReleases {
    numerousReleases {
      id
      name
      body
      publishedAt
    }
  }
`);

export function useNumerousReleases() {
  return useQuery(NUMEROUS_RELEASES);
}
